(function() {
  function initContactForm() {
    const successMessage = document.querySelector('.contact-form-success');
    if (successMessage && window.location.search.includes('contact_posted=true')) {
      successMessage.classList.remove('hidden');
      const url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }

    const phoneInput = document.querySelector('input[name="contact[phone]"]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function() {
        this.value = this.value.replace(/\D/g, '');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactForm);
  } else {
    initContactForm();
  }
})();
